<template>
  <div class="login-wrapper">
    <div class="login-box" style="margin: 0 auto">
      <h3 class="login-box__title">YURT GİRİŞİ</h3>
      <VueButton3
        v-if="showErrorMessage"
        class="red fw shadow-none login-box__submit mycursor1"
        title="Lütfen bilgilerinizi kontrol edin!"
      />
      <v-input placeholder="E-Posta Adresi" v-model="email" />
      <label for="password" v-if="falseEmail" class="myValidationText"
        >Geçersiz e-posta formatı!</label
      >
      <label for="password" v-if="emptyEmail" class="myValidationText"
        >Bu kısım boş geçilemez!</label
      >
      <v-input placeholder="Şifre" type="password" v-model="password" />
      <label for="password" v-if="emptyPassword" class="myValidationText"
        >Bu kısım boş geçilemez!</label
      >
      <router-link class="password-forget" to="/sifremi-unuttum">
        Şifremi Unuttum</router-link
      >
      <v-button
        to="/"
        class="green fw shadow-none login-box__submit"
        title="GİRİŞ YAP"
        @click.native="login"
      />
      <div class="or">
        <p class="or__title">VEYA</p>
      </div>
      <v-button
        class="gray fw shadow-none login-box__submit"
        title="YURDUMU EKLE"
        @click.native="goAddDorm"
      />

      <div class="login-box__bottom">
        <!--         <p class="login-box__bottom-text">Yurtlarburada.com'da yeni misiniz?</p>

        <router-link to="/kayit-ol" class="button button--more color-light-green" style="color: #5567ab !important;">
        <span class="button__wrp"><span class="button__txt">
              ŞİMDİ KAYDOLUN
        </span>
          <span class="button__icon"><svg class="icon">
            <use xlink:href="/icon/icons.svg#icon-arrow-long-right"></use></svg></span></span></router-link>
            -->
        <div>
          <router-link
            to="/uye-girisi"
            class="button button--more color-light-green"
            ><span class="button__wrp">
              <span class="button__txt">
                ÜYE GİRİŞİ
              </span>
              <span class="button__icon">
                <svg class="icon">
                  <use
                    xlink:href="/icon/icons.svg#icon-arrow-long-right"
                  ></use></svg></span></span
          ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueButton3 from '@/components/VueButton3'
import { SET_TOKEN, SET_USER_INFO } from '@/store/mutations.type'
import axios from 'axios'
export default {
  name: 'LoginDorm',
  components: {
    VueButton3
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Yurt Girişi',
      link: [
        { rel: 'canonical', href: window.location.origin + '/yurt-girisi/' }
      ]
    }
  },
  data: function() {
    return {
      showErrorMessage: false,
      errors: [],
      email: '',
      emailBlured: false,
      valid: false,
      submitted: false,
      falseEmail: false,
      emptyEmail: false,
      emptyPassword: false,
      password: null
    }
  },

  methods: {
    closeModal() {
      this.showErrorMessage = false
    },
    goAddDorm() {
      this.$router.push('/yurdumu-ekle')
    },
    validate: function() {
      this.emailBlured = true
      if (this.validEmail(this.email)) {
        this.valid = true
      }
    },

    validateEmail: function(email) {
      var re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },
    login() {
      this.falseEmail = false
      this.emptyPassword = false
      this.emptyEmail = false
      const verifiedMail = this.validateEmail(this.email)
      if (!this.password) {
        this.emptyPassword = true
      }
      if (!this.email) {
        this.emptyEmail = true
      } else if (this.email && !verifiedMail) {
        this.falseEmail = true
      }

      if (verifiedMail && this.password) {
        /*       if (this.validateForm()) {
                console.log('formValidated');
                //submit form to backend
            } */

        // this.validate()
        var self = this
        /*       if(!this.valid) {
        // this.email = 'Mail giriniz'
        this.$refs.input1.value = 'Mail giriniz'
      } */
        // if(this.valid) {
        axios
          .post(`/dorm/login`, {
            email: this.email,
            password: this.password
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              // self.showSuccessMessage = true
              // self.commit(SET_USER_INFO, response.data.user)
              self.$store.commit(SET_USER_INFO, response.data.user)
              const data = { updateLogin: true, isLogin: 'true' }
              self.$store.commit(SET_USER_INFO, data)
              self.$store.commit(SET_TOKEN, response.data.token)

              axios.defaults.headers.common['Authorization'] =
                'Bearer ' + response.data.token
              window.localStorage.setItem('type_id', response.data.user.type_id)
              window.localStorage.setItem(
                'first_name1',
                response.data.user.first_name
              )
              window.localStorage.setItem(
                'last_name1',
                response.data.user.last_name
              )
              window.localStorage.setItem(
                'username1',
                response.data.user.first_name +
                  ' ' +
                  response.data.user.last_name
              )
              window.localStorage.setItem('isLogin', 'true')
              window.localStorage.setItem(
                'cache:dorm_logo',
                response.data.user.logo
              )
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail1', response.data.user.email)
              window.localStorage.setItem('phone1', response.data.user.phone)
              if (response.data.user.logo != null)
                window.localStorage.setItem('logo', response.data.user.logo)
              window.localStorage.setItem(
                'dorm_name',
                response.data.user.dorm_name
              )
              window.localStorage.setItem('pwd', this.password)
              self.$router.push('/yurt-yonetimi/istatistikler')
            } else if (response.status === 422) {
              this.showErrorMessage = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.showErrorMessage = true
              // console.log('hata: ' + error.response);
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/components/login';
.mytext {
  text-align: center;
  size: 10px;
  color: #e4426a;
}
</style>
